<script>

import ScholarshipMeetingApi from "../../Services/Api/MeetingApi/ScholarshipMeetingApi";
import {mapActions, mapState} from "vuex";
import {createHelpers} from "vuex-map-fields";

const {mapFields} = createHelpers({
  getterType: 'scholarship_comment/getPayloadComment',
  mutationType: 'scholarship_comment/updatePayloadComment',
});
export default {
  name: "TheEditAchievementTypeStatementDialog",

  props: {
    visible: Boolean,
  },

  watch: {
    show() {
      if(_.isEmpty(this.achievementTypesList)) this.getAchievementType();

      if (!_.isEmpty(this.statement)) this.prtf_achievement_type_id = this.statement.prtf_achievement_type_id;
    },
  },

  data() {
    return {
      achievementTypesList: [],
      prtf_achievement_type_id: null,
      achievementTypeRules: [
        v => !!v || 'Require!'
      ],
      loading: false,
    };
  },


  computed: {

    ...mapState({
      statement: state => state.scholarship_competition.statement,
    }),

    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }

      }
    },

    ...mapFields([
      "comment",
      "comment_type",
      "payload",
      "scholarship_competition_id",
    ]),

    isCommentEditTypePresent() {
      return !_.isEmpty(this.statement.comment_achievement_type) && !_.isNil(this.statement.comment_achievement_type);
    },
  },

  methods: {

    ...mapActions({
      getStatements: 'scholarship_competition/getStatements',
      getStatement: 'scholarship_competition/getStatement',
      createComment: "scholarship_comment/createComment",
    }),

    async getAchievementType() {
      const response = await ScholarshipMeetingApi.getAchievementType();

      if(_.isNil(response)) return  null;

      this.achievementTypesList = response.data.types;
    },

    async updateAchievementTypeStatement() {
      this.loading = true;

      await this.setCommentPayload();
      await this.createComment();
      await Promise.all([this.getStatements(), this.getStatement(this.statement.id)])

      this.loading = false;
      this.show = false;
    },

    setCommentPayload() {
      const newAchievementType = _.find(this.achievementTypesList, type => type.id === this.prtf_achievement_type_id)
      this.comment = `Предлагается поменять тип деятельности '${this.statement.prtf_achievement_type_name}' на '${newAchievementType.name}'`;
      this.comment_type = 'edit_type';
      this.scholarship_competition_id = this.statement.id;
      this.payload = {
        old_achievement_type: this.statement.prtf_achievement_type_id,
        new_achievement_type: this.prtf_achievement_type_id
      };
    }
  },
}
</script>

<template>
  <v-dialog
    content-class="rounded-xl"
    v-model="show"
    width="500px"
  >
    <v-card
      class="rounded-xl"
    >
      <v-card-title>
        Изменить тип деятельности участника
      </v-card-title>
      <v-card-text>
        <v-form>

        </v-form>
        <v-select
          outlined
          :items="achievementTypesList"
          item-text="name"
          item-value="id"
          v-model="prtf_achievement_type_id"
          color="teal darken-3"
          label="Тип достижения*"
          clearable
          no-data-text="Типы достижений отсутсвуют"
          class="rounded-xl"
          :rules="achievementTypeRules"
          dense
        >
        </v-select>

      </v-card-text>

      <v-card-text>
        Внимание, начнется голосование за изменение типа деятельности!
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="teal darken-3"
          class="rounded-xl"
          outlined
          @click="show=false"
        >
          Закрыть
        </v-btn>
        <v-card-text v-if="isCommentEditTypePresent">
          <v-icon small left color="warning">fa-exclamation</v-icon> Запрос на изменение уже существует
        </v-card-text>
        <v-btn
          v-else
          color="teal darken-3"
          class="white--text rounded-xl"
          @click="updateAchievementTypeStatement"
          :loading="loading"
        >
          Изменить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>